<template>
<div>
	<modal-dialog
		:modal-visible="visible"
		title="Add Material"
		confirm-button-text="Add"
		:submit-visible="true"
		modal-size="modal-lg"
		:working="working"
		v-on:confirm="addMaterials"
		v-on:closeModal="close">

		<slot name="top"></slot>

		<div v-if="payload.length" class="mt-2 mb-4">
			<div v-for="(mat,index) in payload" :key="mat.id+'_'+index" class="row align-items-center">

				<div class="mb-2" :class="{'col-sm-12':disableQty,'col-md-6':!disableQty}">
					<field v-if="mat.findType != 'manual'"
						:params="{type:'text',placeholder: 'Material'}"
						:readonly="true"
						:value="selectedPartLabel(mat)">
					</field>

					<div class="d-flex" v-else>
						<field
							:params="{type:'text',placeholder:'Material',required:mat.qty > 0 ? true : false}"
							v-model="mat.description">
						</field>

						<field :params="{
								type:'text',
								placeholder: 'Part Number'
							}"
							v-model="mat.part_number">
						</field>
					</div>

				</div>
				<div v-if="!disableQty" class="col-md-6 mb-2">

					<div class="d-flex flex-row align-items-center">

						<label class="mb-0 mr-3 text-right" style="font-weight: bold;text-transform: uppercase;min-width:50px;">
							<template v-if="mat.material_unit_type">{{mat.material_unit_type}}</template>
							<template v-else>QTY</template>
						</label>

						<field
							:params="{type:'number',placeholder: 'QTY',step:0.05}"
							:float-control-right="true"
							v-model="mat.qty">
						</field>

						<template v-if="mat.itemType == 'assembly' && mat.assembly.unit_type != 'Unit'">
							<label class="mb-0 mr-1 ml-2" style="font-weight: bold;min-width: 60px;">Linear Qty</label>
							<field
								:params="{type:'number',placeholder: 'Linear Qty',step:1}"
								v-model="mat.linear_qty">
							</field>

							<label class="mb-0 mr-1 ml-2" style="font-weight: bold;min-width: 60px;"># Segs.</label>
							<field
								:params="{type:'number',placeholder: '# Segments',step:1}"
								v-model="mat.num_segments">
							</field>
						</template>
					</div>

				</div>
				<div v-if="!disablePrice && selectedMaterialIsManual && index == payload.length - 1" class="col-md-12 mb-2">

					<button v-if="priceOption != 'set-price'" class="btn btn-light" type="button" v-on:click="priceOption = 'set-price'">
						Set Price{{enableLabour ? '/Labour':''}}
					</button>

					<div v-if="priceOption == 'set-price'" class="d-flex align-items-center">

						<field
							label="Unit Price"
							col-class="col-5"
							class="mr-2"
							:params="{type:'number',placeholder: 'Unit Price',min:0,step:0.01}"
							v-model="mat.price">
						</field>
	
						<field v-if="enableLabour"
							label="Labour/Unit"
							col-class="col-5"
							:params="{type:'number',placeholder: 'Labour/unit',min:0,step:0.001}"
							v-model="mat.labour_hrs">
						</field>


						<i class="ml-4 fa fa-times icon-button" title="Close pricing/labour" v-on:click="priceOption = 'log-expense'"></i>
					</div>

					<i v-if="priceOption != 'set-price'" class="fa fa-trash icon-button" style="margin-left: 15px;position: relative;top: 3px;" v-on:click="removeSelectedMaterial(index)"></i>
				</div>
				<div v-else style="margin: 5px;margin-right: 15px;text-align: right;flex-grow: 1">
					<i class="fa fa-trash icon-button" v-on:click="removeSelectedMaterial(index)"></i>
				</div>

			</div>
		</div>

		<div class="d-flex justify-content-between">
			<field 
				class="mb-2"
				v-model="findType"
				:params="{type:'btn-group',buttons:typeButtons,disableNull:true}"
				v-on:change="changeFindType">		
			</field>

			<div>
				<button type="submit" class="btn btn-primary ml-2">Add</button>
			</div>
		</div>

		<categorized-list-record-selector 
			v-show="findType == 'browse' || findType == 'search' || findType == 'supplier' || findType == 'suggested'"
			v-on:select="setMaterial"
			:suggested-records-and-ids="suggestedMaterials"
			:job-id="jobId"
			:type="findType">
		</categorized-list-record-selector>	
		<template v-if="findType == 'contract'">
			<h3>Materials</h3>
			<table-list 
				:fields="matFields"
				:records="mutateMaterials(contractMaterials)"
				record-name="Material"
				:sortable="true"
				:has-edit="true"
				edit-button-text="Add"
				v-on:edit="setMaterial"
				:hide-record-count='true'>
			</table-list>
		</template>
		<assembly-picker v-else-if="findType == 'assembly'"
			v-on:selectAssembly="setAssembly">
		</assembly-picker>

	</modal-dialog>

	<modal-dialog
		v-if="expenseLogPrompt"
		:modal-visible="expenseLogModal.visible"
		title="Log Expense"
		:submit-visible="false"
		v-on:closeModal="expenseLogModal.visible = false"
		cancel-button-text="Skip">
		<expense-log-form
			v-if="expenseLogModal.visible"
			:title="'Expense for ' +expenseLogModal.data.description"
			:expense-data="{
				description: expenseLogModal.data.description,
				service_id: $store.service.id,
				purchase_date: expenseLogModal.data.purchase_date
			}"
		></expense-log-form>
	</modal-dialog>
</div>
</template>
<script type="text/javascript">
import CategorizedListRecordSelector from "@/components/super_components/CategorizedListRecordSelector"
import ModalDialog from "@/components/ModalDialog"
import Field from "@/components/Field"
import TableList from "@/components/TableList"

import AssemblyPicker from "@/components/super_components/AssemblyPicker"

import ExpenseLogForm from "@/components/super_components/ExpenseLogForm"

export default {
	name: "MaterialSelectorModal",
	components: {
		CategorizedListRecordSelector,
		ModalDialog,
		Field,
		TableList,
		ExpenseLogForm,
		AssemblyPicker
	},
	props: [
		"visible",
		"contractId", 
		"jobId", //if set we will allow an option to select from Job Materials
		"onlyManual", // if set, hide search, browse, and suppliers options
		"serviceId", //if set we will allow an option to select from Service Materials
		"disableManual",
		"disableQty",
		"disablePrice",
		"disableAssemblies",
		"disableSerialNum",
		"disableWarranty",
		"enableLabour",
		"expenseLogPrompt", //if true, manual material selections will be prompted to log an expense
		"suggestedMaterials",
		"working"
	],
	data() {
		return {
			findType: false,
			selectedMaterial: null,
			materialFound: false,
			selectedMaterialIsManual: false,
			contractMaterials: [],
			payload: [], /*{
								id: null,
								description: null,
								part_number: null,
								supplier_number: null,
								price: null,
								labour_hrs: null,
								qty: 0,
								itemType: material/assembly
							},
							{
								description: null,
								qty: 0,
								itemType: material/assembly,
								materials: [],
								num_segments: (int)
							}*/
			matFields: [
				{label: "Description",key:"description"},
				{label: "Part Number", key: "part_number"},
				{label: "Supplier PN", key: "supplier_number"},
				{label: "Category", key: "parentCategoryName"}
			],
			expenseLogModal: {
				visible: false,
				data: {}
			},
			priceOption: 'log-expense',
		}
	},
	watch: {
		contractId() {
			//fetch the appropriate contract materials list
			this.fetchContractMaterials()
		}
	},
	computed: {
		isEditingManualMaterial() {
			return (this.editModal && 'material' in this.editModal && this.editModal.material &&
				'findType' in this.editModal.material && this.editModal.material.findType == 'manual')
		},
		typeButtons() {
			let buttons = [
				{text: 'Search',icon:'fa-search',value:'search'},
				{text: 'Browse',icon:'fa-tags',value:'browse'},
				{text: 'Suppliers',icon:'fa-address-book',value:'supplier'},
			]

			if (this.suggestedMaterials && this.suggestedMaterials.length > 0)
				buttons.push({text: 'Suggested', icon: 'fa-lightbulb', value: 'suggested'})

			if (this.contractId > 0) 
				buttons.push({text: 'Pick From Contract',icon:'fa-gavel',value:'contract'})

			if (!this.disableManual)
				buttons.push({text: 'Add Manually',icon:'fa-pencil-alt',value:'manual'})

			if (!this.disableAssemblies)
				buttons.push({text: 'Add Assembly',icon:'fa-puzzle-piece',value:'assembly'})

			return buttons
		}
	},
	methods: {
		updateMaterial() {
			Object.keys(this.editModal.payload).forEach(key => {
				this.editModal.material[key] = this.editModal.payload[key]
			})
			this.editModal.visible = false
		},
		rand() {
			return Math.random()
		},
		mutateMaterials(materials) {
			return materials.map(mat => {

				mat.parentCategoryName = mat.MaterialCategory.name

				return mat
			})
		},
		selectedPartLabel(part) {
			if (part) {
				if ("part_number" in part && part.part_number)
					return part.part_number + ", " + part.description
				else 
					return part.description
			}
			else
				return ""
		},
		changeFindType() {
			let vm = this

			this.$nextTick(() => {
				if (vm.findType == 'manual') {
					vm.materialFound = true
					vm.payload.push({
						description: "",
						findType: 'manual',
						qty: 1,
						price: "0.00",
						labour_hrs: 0,
						id: this.rand()
					})
					this.selectedMaterialIsManual = true
				}
				else
					vm.materialFound = false
			})
		},
		setAssembly(assemblyDetails) {

			this.payload.push({
				assembly: assemblyDetails.assembly,
				description: assemblyDetails.assembly.description,
				qty: assemblyDetails.qty,
				linear_qty: assemblyDetails.linear_qty,
				itemType: "assembly",
				materials: assemblyDetails.materials,
				num_segments: assemblyDetails.num_segments
			})

			/*let selectedMaterials = JSON.parse(JSON.stringify(assemblyDetails.materials))
			let vm = this

			selectedMaterials.forEach(selectedMaterial => {
				vm.setMaterial(selectedMaterial)
			})*/
		},
		setMaterial(material) {
			let selectedMaterial = JSON.parse(JSON.stringify(material))

			if ("id" in selectedMaterial)
				this.selectedMaterialIsManual = false
			else
				this.selectedMaterialIsManual = true

			let catName = ""
			if ("MaterialCategory" in selectedMaterial && "name" in selectedMaterial.MaterialCategory)
				catName = selectedMaterial.MaterialCategory.name

			//check if this material already exists in payload
			let matIndex = this.payload.findIndex(mat => mat.id == selectedMaterial.id)
			if (matIndex >= 0) {
				this.payload[matIndex].qty++
			}
			else {

				this.payload.push({
					id : selectedMaterial.id,
					qty : 1,
					part_number : selectedMaterial.part_number,
					supplier_number: selectedMaterial.supplier_number,
					description : selectedMaterial.description,
					price : selectedMaterial.material_price,
					price_updated: selectedMaterial.price_updated,
					per: selectedMaterial.per,
					material_unit_type: selectedMaterial.material_unit_type,
					categoryName: catName,
					labour_hrs: selectedMaterial.labour_hrs,
					itemType: "material",
					created_at: selectedMaterial.created_at
				})
			}
			
			this.materialFound = true

			this.selectedMaterial = material
		},
		addMaterials() {

			let vm = this

			let hasManualMaterial = this.payload.find(mat => mat.findType == 'manual')

			if (hasManualMaterial) {

				let description = this.payload.reduce((des,mat) => {
					if (des)
						return des+", "+mat.description
					else
						return mat.description
				},"")

				if (this.priceOption == 'log-expense') {
					this.expenseLogModal.visible = true
					this.expenseLogModal.data = {
						description: description,
						purchase_date: this.moment().format("YYYY-MM-DD")
					}
				}
			}

			this.$emit("addMaterials",this.cloneObj(this.payload))
			this.payload = []
			this.findType = null
			this.materialFound = false
		},
		removeSelectedMaterial(index) {
			this.payload.splice(index,1)
		},
		close() {
			this.$emit("closeModal")
		},
		fetchContractMaterials() {
			let vm = this

			if (this.contractId > 0) {

				let params = {
					include: [
						{
							model:"Material",
							include:[{
								model:"MaterialCategory",
								fields: ["category_id","name","num_materials","id","slug"]
							}]
						}
					],
					fields: ["id","slug","contract_description"]
				}

				this.getJSON("ServiceContract/find/"+this.contractId,params).then(response => {
					if (response.success)
						vm.contractMaterials = response.data.Material
				})
			}
			else
				vm.contractMaterials = []
		}
	},
	created() {
		this.fetchContractMaterials()
	}
}
</script>